import { render, staticRenderFns } from "./myPolicyPush.vue?vue&type=template&id=6d367fe6&scoped=true"
import script from "./myPolicyPush.vue?vue&type=script&lang=js"
export * from "./myPolicyPush.vue?vue&type=script&lang=js"
import style0 from "./myPolicyPush.vue?vue&type=style&index=0&id=6d367fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d367fe6",
  null
  
)

export default component.exports